<template>
  <div>
    <DeletePOIModal
      :show="deletePOIModal"
      v-if="deletePOIModal"
      v-on:closeDeletePOIModal="closeDeletePOIModal"
      :id="removeId"
    />
    <DeleteGeofenceModal
      :show="deleteGeofenceModal"
      v-if="deleteGeofenceModal"
      v-on:closeDeleteGeofenceModal="closeDeleteGeofenceModal"
      :id="removeId"
    />
    <div class="page-wrapper">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        background-color="#f3f3f3"
        :opacity="0.8"
        loader="bars"
      ></loading>

      <CreatePOI
        :show="createPOI"
        v-on:addPOI="addPOI"
        v-on:delete-POI="deletePOI"
        v-on:closeCreatePOI="closeCreatePOI"
        v-on:poi-added="poiAdded"
        :editPOI="editPOI"
      />

      <div v-if="poiAlert" class="POI-alert">
        {{ $t("click_any_poi") }}
      </div>
      <div v-if="geofenceAlert2" class="POI-alert">
        {{ $t("you_are_set") }}
      </div>
      <div v-if="geofenceAlert3" class="POI-alert d-flex flex-column">
        <p>
          {{ $t("doing_well") }}
        </p>
        <div class="w-100 d-flex justify-content-center">
          <button @click="savegeofence" class="btn-maps">
            {{ $t("save") }}
          </button>
        </div>
      </div>

      <div class="page-breadcrumb mb-5">
        <div class="row">
          <div class="col-md-5 align-self-center mb-2">
            <h6 class="font-16 font-weight-bold">{{ $t("maps") }}</h6>
          </div>
          <div class="col-md-7 align-self-center">
            <div
              class="d-flex align-items-center justify-content-end col-gap-1"
            >
              <button
                @click="
                  createPOI = true;
                  editPOI = {};
                "
                class="btn btn-secondary"
              >
                {{ $t("create_poi") }}
              </button>
              <button
                @click="
                  createGeofence = true;
                  showCreateGeo = true;
                  editGeo = {};
                "
                class="btn btn-secondary"
              >
                {{ $t("create_geo") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row container-fluid pt-0 mt-0 pr-0">
        <div class="col-12 col-sm-7 col-md-8 col-lg-9">
          <div class="row mb-3">
            <div class="col-lg-6 col-md-6">
              <IconCard
                :label="$t('poi')"
                :title="poiMeta.totalItems"
                :iconColor="'background-color: rgba(158, 198, 221, 0.30);'"
              >
                <template slot="icon">
                  <icon-location />
                </template>
              </IconCard>
            </div>
            <div class="col-lg-6 col-md-6">
              <IconCard
                :label="$t('geo')"
                :title="geofenceMeta.totalItems"
                iconColor="background-color: rgba(143, 205, 159, 0.30)"
              >
                <template slot="icon">
                  <IconHouse />
                </template>
              </IconCard>
            </div>
          </div>
          <div class="row page-wrapper mt-0 pt-0 ml-0 position-relative">
            <div
              class="d-flex p-3 align-items-center create-point bg-white"
              v-if="showFinishGeo"
            >
              <p class="mb-0">
                {{
                  this.editGeo.id ? $t("edit_geo_text") : $t("create_geo_text")
                }}
              </p>

              <div class="d-flex align-items">
                <button class="btn-primary btn ml-3" @click="savegeofence">
                  {{ $t("finish") }}
                </button>
                <button
                  class="btn-secondary btn ml-3"
                  @click="cancelEditGeo"
                  v-if="editGeo.id"
                >
                  {{ $t("cancel") }}
                </button>
              </div>
            </div>
            <CreateGeofence
              :show="createGeofence"
              v-if="createGeofence"
              v-on:addgeofence="
                createGeofence = false;
                showFinishGeo = true;
              "
              v-on:delete-geofence="deleteGeofence"
              v-on:closeCreateGeofence="closeCreateGeofence"
              @color="updateColorName"
              :isDisabled="isDisabled"
              @reset_map="reset"
              @searchLocation="doSearch"
              :map="map"
              :geofenceAlert="geofenceAlert"
              @clear_geofenceAlert="geofenceAlert = false"
              :editGeo="editGeo"
            />
            <LiveMap
              :devices="mapdevices"
              v-show="!createGeofence && !showCreateGeo"
              :POIname="POIname"
              :POI="POI"
              :addpoi="addpoi"
              :geofencename="geofencename"
              :geofencecolor="geofencecolor"
              :geofence="geofence"
              :addgeofence="addgeofence"
              :POIhandler="POIhandler"
              :geofencehandler="geofencehandler"
              v-else-if="mapShow"
              v-on:geofence-firstclick="geoFirstClick"
              v-on:geofence-secondclick="geoSecondClick"
              v-on:poi-added="poiAdded"
              :editPOI="editPOI"
              :selectedPOI="selectedPOI"
              @poi-edited="poiEdited"
            />
            <GroupLiveMap
              :group="groupInFocus"
              v-else
              :POIname="POIname"
              v-show="!createGeofence && !showCreateGeo"
              :POI="POI"
              :addpoi="addpoi"
              :geofencename="geofencename"
              :geofencecolor="geofencecolor"
              :geofence="geofence"
              :addgeofence="addgeofence"
              :POIhandler="POIhandler"
              :geofencehandler="geofencehandler"
              v-on:geofence-firstclick="geoFirstClick"
              v-on:geofence-secondclick="geoSecondClick"
              v-on:poi-added="poiAdded"
            />
            <CreateGoefenceV2
              v-if="showCreateGeo"
              :geofence="geofence"
              :location="location"
              :geoObject="geoObject"
              :reset_map="reset_map"
              @polygonCoords="updatePolygonCoords"
              @locationNotFound="
                geofenceAlert = true;
                isDisabled = false;
              "
              :place="place"
              @theMap="getMap"
              :editGeo="editGeo"
              :selectedGeo="selectedGeo"
            />
          </div>
        </div>
        <div class="col-12 col-sm-5 col-md-4 col-lg-3">
          <div class="card mb-4">
            <div class="card-body">
              <div
                class="d-flex align-items-center justify-content-between col-gap-1 col-12"
              >
                <div class="btn-container">
                  <button
                    @click="
                      geo = true;
                      poi = false;
                    "
                    :disabled="geo == true"
                    id="graphselect"
                  >
                    {{ $t("geo") }}
                  </button>
                </div>
                <div class="btn-container">
                  <button
                    @click="
                      poi = true;
                      geo = false;
                      showCreateGeo = false;
                    "
                    :disabled="poi == true"
                    id="graphselect"
                  >
                    {{ $t("poi") }}
                  </button>
                </div>
              </div>
              <div id="poi-geofence" class="mb-3 overflow-auto">
                <div class="col-sm-12 col-md-12 my-3">
                  <table-search @handleSearch="activeViewSearch" />
                </div>
                <div class="overflow-auto" style="max-height: 10rem">
                  <table class="w-100">
                    <thead class="data-table-bg">
                      <tr class="">
                        <th class="py-3 px-2">
                          <input
                            type="checkbox"
                            @change="handleSelectAllGeoAndPOI"
                            :checked="
                              activeView.length === activeCheckBoxes.length
                            "
                          />
                        </th>
                        <th class="py-3 px-2">
                          {{ this.geo ? $t("geo") : $t("poi") }}
                        </th>
                        <th class="py-3 px-2">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        :class="{
                          'data-table-bg': index % 2 !== 0,
                        }"
                        v-for="(view, index) in activeView"
                        :key="view.id"
                      >
                        <td class="py-3 px-2">
                          <input
                            type="checkbox"
                            :checked="
                              activeCheckBoxes.some((obj) => obj.id === view.id)
                            "
                            @change="selectGeo(view)"
                          />
                        </td>
                        <td class="py-3 px-2">
                          {{ view.name }}
                        </td>
                        <td class="py-3 px-2">
                          <div class="d-flex align-items-center col-gap-1">
                            <span
                              class="cursor-pointer"
                              @click="handleEdit(view)"
                            >
                              <IconEditUser />
                            </span>
                            <span
                              @click="deletePOIGeo(view.id)"
                              class="cursor-pointer"
                            >
                              <IconDeleteUser />
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body overflow-auto">
              <div id="poi-geofence" class="mb-3">
                <div id="devices" class="col-12 p-0">
                  <div
                    class="d-flex align-items-center col-gap-1 justify-content-around col-12"
                  >
                    <div class="btn-container">
                      <button
                        @click="showDevices"
                        id="graphselect"
                        class="btn d-flex"
                        :class="{ 'device-selected': devicesView }"
                      >
                        {{ $t("devices") }}
                        <span class="ml-2">({{ activedevices2.length }})</span>
                      </button>
                    </div>
                    <div class="btn-container">
                      <button
                        @click="showGroups"
                        :class="{ 'device-selected': groupsView }"
                        id="graphselect"
                        class="btn d-flex"
                      >
                        {{ $t("groups") }}
                        <span class="ml-2">({{ activegroups.length }})</span>
                      </button>
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between py-3 px-2 bg-white position-relative"
                  >
                    <table-search
                      @handleSearch="search"
                      :placeholder="$t('devices')"
                      :searchQuery="searchIndex"
                    />
                    <div
                      v-if="devicesView"
                      class="justify-content-center align-items-center ml-2"
                      :class="{ show: filterMenu }"
                      @click="filterMenu = !filterMenu"
                    >
                      <IconFilter />
                    </div>
                    <div class="filter-menu" v-if="filterMenu">
                      <div class="py-3 px-2 filter-menu-header">
                        {{ $t("filter_by") }}
                      </div>
                      <div
                        class="px-2 py-3 filter-menu-body"
                        @click="filterDevices('in-range')"
                      >
                        {{ $t("dev_wit") }}
                      </div>
                      <div
                        class="px-2 py-3 filter-menu-body"
                        @click="filterDevices('out-range')"
                      >
                        {{ $t("dev_out") }}
                      </div>
                      <div
                        class="px-2 py-3 filter-menu-body border-0"
                        @click="filterDevices('all')"
                      >
                        {{ $t("all_dev") }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="devicesView && activedevices2.length !== 0"
                    class="d-flex align-items-center mr-3 py-2 px-3"
                    style="
                      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                      margin-bottom: 10px;
                    "
                  >
                    <div class="checkbox-box mr-2" @click="selectAllOption">
                      <img
                        v-if="selectAll"
                        src="../../assets/images/checkbox.svg"
                        alt=""
                      />
                    </div>
                    {{ $t("sel_all") }}
                  </div>
                  <div class="bg-white card-height" style="overflow-y: auto">
                    <div v-if="devicesView">
                      <DeviceCard
                        :key="device.id"
                        v-for="device in activedevices2"
                        :device="device"
                        :selectAll="selectAll"
                        v-on:check-device="checkDevice"
                      />
                      <div class="py-3 px-2" v-if="activedevices2.length == 0">
                        {{ $t("no_dev") }}
                      </div>
                    </div>
                    <div v-if="groupsView">
                      <GroupCard
                        :key="group.id"
                        v-for="group in activegroups"
                        :groupInFocus="groupInFocus"
                        v-on:view-group="viewGroup"
                        :group="group"
                      />
                      <div class="py-3 px-2" v-if="activegroups.length == 0">
                        {{ $t("no_grp") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import LiveMap from "../../components/Devices/LiveMap";
import GroupLiveMap from "../../components/Groups/GroupLiveMap";
import DeviceCard from "../../components/DeviceCard";
import GroupCard from "../../components/GroupCard";
import CreatePOI from "../../components/CreatePOI";
import CreateGeofence from "../../components/CreateGeofence";
import DeletePOIModal from "../Modals/DeletePOIModal";
import DeleteGeofenceModal from "../Modals/DeleteGeofenceModal";
import CreateGoefenceV2 from "../../components/CreateGoefenceV2.vue";
import IconFilter from "../../components/Iconsvg/IconFilter";
import IconCard from "../../components/IconCard.vue";
import TableSearch from "../../components/TableSearch.vue";
import IconEditUser from "../../components/Iconsvg/IconEditUser.vue";
import IconDeleteUser from "../../components/Iconsvg/IconDeleteUser.vue";
import IconLocation from "../../components/Iconsvg/IconLocation.vue";
import IconHouse from "../../components/Iconsvg/IconHouse.vue";

export default {
  name: "Map",
  props: {
    check: String,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      mapdevices: [],
      activedevices: [],
      activedevices2: [],
      activegroups: [],
      activePOI: [],
      activegeofence: [],
      mapShow: true,
      devicesView: true,
      groupsView: false,
      POIname: "",
      geofencename: "",
      geofencecolor: "",
      addpoi: false,
      createPOI: false,
      createGeofence: false,
      viewPOIList: false,
      viewGeofenceList: false,
      addgeofence: false,
      groupInFocus: "",
      searchIndex: "",
      deletePOIModal: false,
      deleteGeofenceModal: false,
      deviceMenu: true,
      poiAlert: false,
      geofenceAlert: false,
      geofenceAlert2: false,
      geofenceAlert3: false,
      successToast: false,
      successToastGeo: false,
      POIhandler: false,
      geofencehandler: false,
      Interval: "",
      filterMenu: false,
      filterOption: "all",
      selectAll: true,
      location: "",
      geoObject: {},
      isDisabled: true,
      coordinates: [],
      reset_map: true,
      autoComplete: "",
      place: null,
      map: null,
      geo: true,
      poi: false,
      showCreateGeo: false,
      showFinishGeo: false,
      editPOI: {},
      editGeo: {},
      selectedGeo: [],
      selectedPOI: [],
    };
  },
  components: {
    Loading,
    LiveMap,
    GroupLiveMap,
    DeviceCard,
    GroupCard,
    CreatePOI,
    CreateGeofence,
    CreateGoefenceV2,
    DeletePOIModal,
    DeleteGeofenceModal,
    IconFilter,
    IconCard,
    TableSearch,
    IconEditUser,
    IconDeleteUser,
    IconLocation,
    IconHouse,
  },
  watch: {
    geofence: {
      handler: function () {
        this.activegeofence = this.geofence;
        this.removeDeletedGeo();
        if (this.selectedGeo.length > 0) {
          this.editGeo = {};
          this.showFinishGeo = false;
        } else this.cancelEditGeo();
      },
      deep: true,
    },
    POI: {
      handler: function () {
        this.activePOI = this.POI;
        this.removeDeletedPOI();
      },
      deep: true,
    },
    createPOI: {
      handler: function () {
        if (this.createPOI) {
          this.viewGeofenceList = false;
          this.POIhandler = !this.POIhandler;
        }
      },
      deep: true,
    },
    createGeofence: {
      handler: function () {
        if (this.createGeofence) {
          this.viewPOIList = false;
          this.geofencehandler = !this.geofencehandler;
        }
      },
      deep: true,
    },
    selectedGeo: {
      handler: function (val) {
        if (this.editGeo.id && val.length > 0) {
          this.showFinishGeo = false;
          this.editGeo = {};
        }
      },
      deep: true,
    },
    geo: {
      handler: function () {
        if (this.geo) {
          if (this.selectedGeo.length > 0) {
            this.showCreateGeo = true;
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchGroups()
      .then(() => {
        if (this.profile.role !== "staff") {
          this.activegroups = this.groups;
        } else {
          this.activegroups = this.groups.filter((group) =>
            group.users.includes(this.profile.id),
          );
        }
        this.groupInFocus = this.activegroups[0];
      })
      .then(() => {
        this.isLoading = false;
      })
      .catch((err) => {
        console.error(err);
        this.isLoading = false;
      });
    this.fetchallDevices()
      .then(() => {
        if (this.profile.role !== "staff") {
          let devicesclone = this.devices.filter(
            (device) => device.type.toLowerCase() !== "lora" && device.type.toLowerCase() !== "glog5",
          );
          this.mapdevices = devicesclone;
          this.activedevices = devicesclone;
          this.activedevices2 = devicesclone;
        } else {
          let devicesclone = this.devices.filter(
            (device) => device.type.toLowerCase() !== "lora" && device.type.toLowerCase() !== "glog5",
          );
          this.activedevices = devicesclone;
          this.activedevices2 = devicesclone;
          this.mapdevices = devicesclone;
        }
        this.deviceInFocus = this.activedevices[0];
      })
      .catch((err) => console.error(err));
    this.fetchPOI().then(() => {
      this.activePOI = this.POI;
    });
    this.fetchGeofence().then(() => {
      this.activegeofence = this.geofence;
    });
    this.startInterval();
  },

  computed: {
    ...mapGetters([
      "devices",
      "groups",
      "profile",
      "geofence",
      "POI",
      "geofenceMeta",
      "poiMeta",
    ]),
    activeView() {
      return this.geo ? this.activegeofence : this.activePOI;
    },
    activeViewSearchData() {
      return this.geo ? this.geofence : this.POI;
    },
    activeCheckBoxes() {
      return this.geo ? this.selectedGeo : this.selectedPOI;
    },
  },
  methods: {
    ...mapActions([
      "fetchallDevices",
      "fetchPOI",
      "fetchGeofence",
      "addGeofenceAPI",
      "fetchGroups",
      "editGeofenceAPI",
    ]),
    startInterval() {
      this.Interval = this.fetchallDevices()
        .then(() => {
          if (this.profile.role !== "staff") {
            this.activedevices = this.devices.filter(
              (device) => device.type.toLowerCase() !== "lora" && device.type.toLowerCase() !== "glog5",
            );
          } else {
            let devicesclone = this.devices.filter(
              (device) => device.type.toLowerCase() !== "lora" && device.type.toLowerCase() !== "glog5",
            );
            this.activedevices = devicesclone;
          }

          if (this.filterOption == "in-range") {
            this.activedevices2 = this.activedevices.filter(
              (device) => device.status == "good",
            );
          } else if (this.filterOption == "out-range") {
            this.activedevices2 = this.activedevices.filter(
              (device) => device.status !== "good",
            );
          } else if (this.filterOption == "all") {
            this.filterOption = "all";
            this.activedevices2 = this.activedevices;
          }

          let mapdevices = [];
          for (let i = 0; i < this.mapdevices.length; i++) {
            let j = 0;
            while (j < this.activedevices2.length) {
              if (this.mapdevices[i].id === this.activedevices2[j].id) {
                mapdevices.push(this.activedevices2[j]);
                break;
              }
              j++;
            }
          }
          this.mapdevices = mapdevices;
        })
        .catch((err) => console.error(err));
    },
    resetState() {
      this.searchIndex = "";
      this.activedevices2 = this.activedevices;
      if (this.profile.role !== "staff") {
        this.activegroups = this.groups;
      } else {
        this.activegroups = this.groups.filter((group) =>
          group.users.includes(this.profile.id),
        );
      }
    },
    showDevices() {
      this.resetState();
      this.mapShow = true;
      this.devicesView = true;
      this.groupsView = false;
    },
    showGroups() {
      this.resetState();
      this.devicesView = false;
      this.groupsView = true;
      this.mapShow = false;
    },
    checkDevice(event) {
      if (event.checked == false) {
        this.mapdevices = this.mapdevices.filter(
          (device) => device.id != event.device.id,
        );
      } else {
        this.mapdevices.push(event.device);
      }
    },
    viewGroup(event) {
      this.groupInFocus = event;
    },
    search({ target: { value } }) {
      if (this.devicesView) {
        this.activedevices2 = this.devices.filter((device) =>
          device.settings.name.toLowerCase().includes(value.toLowerCase()),
        );
      }
      if (this.groupsView) {
        if (this.profile.role !== "staff") {
          this.activegroups = this.groups.filter((group) =>
            group.name.toLowerCase().includes(value.toLowerCase()),
          );
        } else {
          this.activegroups = this.groups.filter((group) =>
            group.name.toLowerCase().includes(value.toLowerCase()),
          );
        }
      }
    },
    closeMenu() {
      this.deviceMenu = !this.deviceMenu;
      let deviceMenu = document.getElementById("devices");
      let closetab = document.getElementById("closetab");
      if (!closetab.classList.contains("closetab-hidden")) {
        closetab.classList.add("closetab-hidden");
      } else {
        closetab.classList.remove("closetab-hidden");
      }
      if (!deviceMenu.classList.contains("devices-hidden")) {
        deviceMenu.classList.add("devices-hidden");
      } else {
        deviceMenu.classList.remove("devices-hidden");
      }
    },
    addPOI(name) {
      this.POIname = name;
      this.addpoi = true;
      this.poiAlert = true;
      this.closeCreatePOI();
      this.$emit("disable-geoCreate");
      clearInterval(this.Interval);
    },
    addGeofence(object) {
      this.geofencename = object.name;
      this.geofencecolor = object.color;
      this.addgeofence = true;
      this.closeCreateGeofence();
      this.$emit("disable-POICreate");
      this.geofenceAlert = true;
      clearInterval(this.Interval);
    },
    savegeofence() {
      this.isLoading = true;
      const geofence = {
        name: this.geoObject.name,
        latlngs: this.coordinates,
      };
      this.isLoading = true;
      this.addgeofence = false;
      this.$emit("disable-POICreate");
      if (this.editGeo.id) {
        return this.editGeofenceAPI({
          id: this.editGeo.id,
          geofence: { latlngs: this.coordinates, name: this.editGeo.name },
        })
          .then(() => {
            this.showCreateGeo = false;
            this.reset();
            this.geofenceAlert3 = false;
            this.successToastGeo = true;
            this.showFinishGeo = false;
            this.editGeo = {};
            this.fetchGeofence().then(() => {
              this.isLoading = false;
              setTimeout(() => {
                this.successToastGeo = false;
              }, 2000);
            });
          })
          .catch((err) => (this.isLoading = false));
      }
      this.addGeofenceAPI({ geofence })
        .then(() => {
          this.showCreateGeo = false;
          this.reset();
          this.geofenceAlert3 = false;
          this.successToastGeo = true;
          this.showFinishGeo = false;
          this.fetchGeofence().then(() => {
            this.isLoading = false;
            setTimeout(() => {
              this.successToastGeo = false;
            }, 2000);
          });
        })
        .catch((err) => (this.isLoading = false));
      this.startInterval();
    },
    deletePOI(id) {
      this.deletePOIModal = true;
      this.removeId = id;
    },
    deleteGeofence(id) {
      this.deleteGeofenceModal = true;
      this.removeId = id;
      this.showFinishGeo = false;
    },
    deletePOIGeo(id) {
      this.removeId = id;
      this.geo
        ? (this.deleteGeofenceModal = true)
        : (this.deletePOIModal = true);
    },
    handleEdit(item) {
      if (this.geo) {
        if (this.selectedGeo.length > 0) {
          this.selectedGeo = [];
        }
        this.editGeo = item;
        this.showFinishGeo = true;
        this.showCreateGeo = true;
      } else {
        if (this.selectedPOI.length > 0) {
          this.selectedPOI = [];
        }
        this.editPOI = item;
        this.createPOI = true;
      }
    },
    closeDeletePOIModal() {
      this.deletePOIModal = false;
      this.fetchPOI()
        .then(() => {
          this.activePOI = this.POI;
        })
        .catch((err) => console.error(err));
    },
    closeDeleteGeofenceModal() {
      this.deleteGeofenceModal = false;
    },
    removeDeletedGeo() {
      const hasSelectedGeo = this.selectedGeo.length > 0;
      const removeIdNotActive = !this.activegeofence.some(
        ({ id }) => id === this.removeId,
      );

      if (hasSelectedGeo && removeIdNotActive && !this.editGeo.id) {
        this.selectedGeo = this.selectedGeo.filter(
          (obj) => obj.id !== this.removeId,
        );
        if (this.selectedGeo.length === 0) {
          this.showCreateGeo = false;
        }
      }
    },
    removeDeletedPOI() {
      const hasSelectedPOI = this.selectedPOI.length > 0;
      const removeIdNotActive = !this.activePOI.some(
        ({ id }) => id === this.removeId,
      );

      if (hasSelectedPOI && removeIdNotActive && !this.editPOI.id) {
        this.selectedPOI = this.selectedPOI.filter(
          (obj) => obj.id !== this.removeId,
        );
      }
    },

    poiAdded() {
      this.poiAlert = false;
      this.addpoi = false;
      this.$emit("disable-geoCreate");
      this.successToast = true;
      this.fetchPOI().then(() => {
        setTimeout(() => {
          this.successToast = false;
        }, 2000);
      });
    },
    geoFirstClick() {
      this.geofenceAlert = false;
      this.geofenceAlert2 = true;
    },
    geoSecondClick() {
      this.geofenceAlert2 = false;
      this.geofenceAlert3 = true;
    },
    filterDevices(params) {
      if (params == "in-range") {
        this.filterOption = "in-range";
        this.activedevices2 = this.activedevices.filter(
          (device) => device.status == "good",
        );
        this.mapdevices = this.activedevices2;
      } else if (params == "out-range") {
        this.filterOption = "out-range";
        this.activedevices2 = this.activedevices.filter(
          (device) => device.status !== "good",
        );
        this.mapdevices = this.activedevices2;
      } else if (params == "all") {
        this.filterOption = "all";
        this.activedevices2 = this.activedevices;
        this.mapdevices = this.activedevices2;
      }
      this.filterMenu = false;
    },
    selectAllOption() {
      this.selectAll = !this.selectAll;
      if (!this.selectAll) {
        this.mapdevices = [];
      } else {
        this.mapdevices = this.activedevices2;
      }
    },
    doSearch(object) {
      this.location = object.location;
      this.place = object.viewport;
    },
    updateColorName(object) {
      this.geoObject = object;
    },
    reset() {
      this.reset_map = !this.reset_map;
      this.autoComplete = "";
      this.location = "";
    },
    updatePolygonCoords(latLng) {
      this.coordinates = latLng;
      if (latLng.length > 0) {
        this.isDisabled = false;
      } else this.isDisabled = true;
    },
    getMap(map) {
      this.map = map;
    },
    closeCreatePOI() {
      this.createPOI = false;
      // this.editPOI = {};
    },
    closeCreateGeofence() {
      this.createGeofence = false;
      this.showCreateGeo = false;
    },
    activeViewSearch({ target: { value } }) {
      let filteredData = this.activeViewSearchData.filter((data) =>
        data.name.toLowerCase().includes(value.toLowerCase()),
      );
      this.geo
        ? (this.activegeofence = filteredData)
        : (this.activePOI = filteredData);
    },
    cancelEditGeo() {
      this.showFinishGeo = false;
      this.showCreateGeo = false;
      this.editGeo = {};
    },
    selectGeo(geo) {
      if (this.geo) {
        this.selectedPOI = [];

        if (this.selectedGeo.some((obj) => obj.id === geo.id)) {
          this.selectedGeo = this.selectedGeo.filter(
            (obj) => obj.id !== geo.id,
          );
        } else {
          this.selectedGeo.push(geo);
        }

        if (this.selectedGeo.length === 0) {
          this.showCreateGeo = false;
        } else this.showCreateGeo = true;
      } else {
        this.selectedGeo = [];
        this.createGeofence = false;
        if (this.selectedPOI.some((obj) => obj.id === geo.id)) {
          this.selectedPOI = this.selectedPOI.filter(
            (obj) => obj.id !== geo.id,
          );
        } else {
          this.selectedPOI.push(geo);
        }
      }
    },
    handleSelectAllGeoAndPOI() {
      if (this.geo) {
        if (this.selectedGeo.length === this.activeView.length) {
          this.selectedGeo = [];
          this.showCreateGeo = false;
        } else {
          this.selectedGeo = this.activeView;
          this.showCreateGeo = true;
        }
      } else {
        if (this.selectedPOI.length === this.activeView.length) {
          this.selectedPOI = [];
        } else {
          this.selectedPOI = this.activeView;
        }
      }
    },
    poiEdited(data) {
      this.selectedPOI = [data];
      this.poiAdded();
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$emit("closemapInner");
    clearInterval(this.Interval);
    next();
  },
};
</script>

<style scoped>
.POI-alert {
  z-index: 2000;
  position: fixed;
  padding: 20px;
  top: 10vh;
  left: calc(50% - 160px);
  background: rgba(228, 169, 122, 0.9);
  border: 0.2px solid #e4a97a;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}
.btn-maps {
  background: #f2f5f7;
  padding: 10px 23px;
  color: #30b24b;
  border: 1px solid #e1e7ec;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  outline: none;
}
.filter-card {
  border: 0.5px solid #e1e7ec;
  border-radius: 3px;
  height: 50px;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 45px;
  margin-bottom: 10px;
  cursor: pointer;
}
.filter-menu {
  position: absolute;
  top: 70px;
  right: 20px;
  background: #fff;
  border-radius: 4px;
  width: 180px;
  /* border: 0.2px solid rgba(0, 0, 0, 0.37); */
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
}
.filter-menu-header {
  background: #ececec;
  border-radius: 4px 4px 0px 0px;
  border: 0.3px solid rgba(0, 0, 0, 0.1);
}
.filter-menu-body {
  border-bottom: 0.3px solid rgba(94, 106, 121, 0.4);
  font-size: 13px;
  line-height: 17px;
  cursor: pointer;
}
.filter-card.show {
  border: 0.5px solid #213e7a;
}
</style>
<style>
.filter-card.show svg path {
  stroke: #213e7a;
  fill: #213e7a;
}
.checkbox-box {
  height: 14px;
  width: 14px;
  border: 0.5px solid rgba(34, 34, 34, 0.9);
  box-sizing: border-box;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

#graphselect {
  background-color: inherit;
  border: none;
  color: #213e7a;
  padding: 7px 25px;
  border-radius: 30px;
  outline: none;
}
#graphselect:hover {
  background-color: #213e7a;
  color: white;
}
#graphselect:disabled,
#graphselect[disabled],
#graphselect.device-selected {
  background-color: #dee2eb;
  color: #213e7a;
}
.create-point {
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  z-index: 1000;
  bottom: 27px;
  position: absolute;
}

@media (max-width: 1200px) {
  .create-point {
    width: 80%;
  }
}

.pac-container {
  /* background-color: #FFF; */
  z-index: 10000 !important;
  /* position: fixed;
    display: inline-block; */
}

.card-height {
  height: calc(100vh - 35px - 26px - 30px - 40px - 137px - 98px - 30px);
}
</style>
<style scoped src="../../assets/css/dashboard/dashboard.css"></style>

<i18n>
{
	"en": {
		"all_dev": "All Devices",
		"click_any_geo": "Location cannot be processed. Please click on the map to draw geofence.",
		"click_any_poi": "Click anywhere on the map to create your POI",
		"dev_out": "Devices outside Range",
		"dev_wit": "Devices within Range",
		"doing_well": "You are doing well, keep clicking to draw your polygon , or click 'Save' if completed to save.",
		"filter_by": "Filter by:",
		"no_dev": "You have no devices",
		"no_grp": "You have no groups",
		"sel_all": "Select all",
		"you_are_set": "You are set to draw your geo-fence, continue to make a line to form a polygon."
	},
	"es": {
		"all_dev": "Todos los dispositivos",
		"click_any_geo": "No se puede procesar la ubicación. Haga clic en el mapa para dibujar la geocerca.",
		"click_any_poi": "Haga clic en cualquier parte del mapa para crear su PDI",
		"dev_out": "Dispositivos fuera de rango",
		"dev_wit": "Dispositivos dentro del rango",
		"doing_well": "Lo está haciendo bien, siga haciendo clic para dibujar su polígono, o haga clic en 'Guardar' si completó para guardar.",
		"filter_by": "Filtrado por:",
		"no_dev": "No tienes dispositivos",
		"no_grp": "no tienes grupos",
		"sel_all": "Seleccionar todo",
		"you_are_set": "Está listo para dibujar su geo-cerca, continúe haciendo una línea para formar un polígono."
	},
	"fr": {
		"all_dev": "Tous les dispositifs",
		"click_any_geo": "Cliquez n'importe où sur la carte pour commencer à créer votre géo-barrière",
		"click_any_poi": "Cliquez n'importe où sur la carte pour créer votre POI",
		"dev_out": "Appareils hors de portée",
		"dev_wit": "Appareils à portée",
		"doing_well": "Vous vous en sortez bien, continuez à cliquer pour dessiner votre polygone ou cliquez sur « Enregistrer » si vous avez terminé pour enregistrer.",
		"filter_by": "Filtrer par:",
		"no_dev": "Vous n'avez aucun appareil",
		"no_grp": "Vous n'avez aucun groupe",
		"sel_all": "Tout sélectionner",
		"you_are_set": "Vous êtes prêt à dessiner votre géo-barrière, continuez à tracer une ligne pour former un polygone."
	},
	"sw": {
		"all_dev": "Vifaa Vyote",
		"click_any_geo": "Eneo haliwezi kuchakatwa. Tafadhali bofya kwenye ramani ili kuchora geofence.",
		"click_any_poi": "Bofya popote kwenye ramani ili kuunda POI yako",
		"dev_out": "Vifaa vilivyo nje ya Masafa",
		"dev_wit": "Vifaa ndani ya Masafa",
		"doing_well": "Unaendelea vyema, endelea kubofya ili kuchora poligoni yako, au ubofye 'Hifadhi' ikiwa imekamilika ili kuhifadhi.",
		"filter_by": "Chuja kwa:",
		"no_dev": "Huna vifaa",
		"no_grp": "Huna vikundi",
		"sel_all": "Chagua Zote",
		"you_are_set": "Umewekwa kuchora uzio wako wa geo, endelea kutengeneza mstari kuunda poligoni."
	}
}
</i18n>
